import * as idEndpoints from './id';
import { id, root } from './web-event-profiles';

export const webEventProfiles = {
  ...root,
  id: {
    ...id,
    ...idEndpoints,
  },
};
